// This file is created as a place to share constants when there could
// be a circular dependency.
// If you have an import in here, then you aren't using this file right.

export const WINDOW_PROP_LOG_HTTP_REQ_TIMES = 'AUJS_LOG_EXC_HTTP_REQ';
